import { render } from "./index.vue?vue&type=template&id=f6c3eba0"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/maintenance_histories/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f6c3eba0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f6c3eba0', __exports__)) {
    console.log('reload')
    api.reload('f6c3eba0', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=f6c3eba0", () => {
    console.log('re-render')
    api.rerender('f6c3eba0', render)
  })

}


export default __exports__